var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"bulk-cluster-modal","modal-class":"modal-fullscreen","centered":"","scrollable":"","size":"lg","title":"Bulk Cluster","hide-footer":""}},[_c('BulkClusterForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }